import React from "react";
import AppRoute from "./route/AppRoute";
import DefaultSEO from "./components/common/DefaultSEO";

function App() {
  return (
    <div>
      <AppRoute />
        <DefaultSEO />
    </div>
  );
}

export default App;








